export default function scrollScreenToTop(
  scrollContainer: Element | undefined
) {
  if (scrollContainer) {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    // Typescript complains about the options passed to scrollTo on the Element type,
    // even though its valid: https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollTo
    scrollContainer.scrollTo(scrollContainer.scrollLeft, 0, {
      behavior: "smooth",
    })
  }
}
